import clsx from "clsx";
import { motion } from "framer-motion";
import { Dispatch, ReactElement, SetStateAction, useRef } from "react";

const fadeVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export function ModalCenter(props: {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  children: ReactElement;
  isHeader?: boolean;
  title: string;
  className?: string;
  clickOutside?: () => void;
  headerClassname?: string;
  headerContainer?: string;
}) {
  const {
    isVisible,
    setIsVisible,
    children,
    isHeader = true,
    title,
    className = "",
    clickOutside,
    headerClassname,
    headerContainer,
  } = props;
  const modalRef = useRef<HTMLDivElement>(null);

  return (
    <>
      {isVisible && (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={fadeVariants}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-[99999] flex items-center justify-center  pointer-events-auto"
          id="modal-center"
        >
          <div
            className="fixed bg-black/20 inset-0 z-19 backdrop"
            style={{
              backdropFilter: "blur(6px)",
            }}
            onClick={() => {
              if (clickOutside) {
                clickOutside();
              }
              setIsVisible((v) => !v);
            }}
          />

          <div
            ref={modalRef}
            className={clsx(
              "z-20 p-6 rounded-2xl bg-black6 w-full max-w-[400px] transition-all modal-content",
              className
            )}
          >
            {isHeader && (
              <div className={clsx("flex items-center justify-between mb-4", headerContainer)}>
                <div className="w-8 h-8" />

                <h2 className={clsx("text-[24px] leading-8 font-medium", headerClassname)}>{title}</h2>
              </div>
            )}

            {children}
          </div>
        </motion.div>
      )}
    </>
  );
}
